<template>
  <div class="menu-container">
    <van-cell-group>
      <van-cell title="我的订单" icon="orders-o" is-link to="/home/order/list" />
      <van-cell
        title="我要下单"
        icon="shopping-cart-o"
        is-link
        label="晚上20：00~第二天凌晨4:00"
        
        @click="onCheckOrder"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { OrderModel } from "@models/common/order";
const orderModel = new OrderModel()
export default {
  data() {
    return {
      complete: false
    };
  },
  methods: {
    onCheckOrder() {
      orderModel.checkAddOrderTime({}).then(res=>{
        if(!res.data == false) {
          this.$toast('亲还没到下单时间段哦!');
        }else{
          this.$redirect('/home/order/add')
        }
      })
      
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@style/varibles.styl';

.menu-container {
  background: #f2f3f5;
}
</style>
